export function formatBigInt(input: string | bigint): string {
  return BigInt(input).toLocaleString()
}
